export default "__VITE_ASSET__BiXYzkTr__"